import { createFileRoute } from "@tanstack/react-router";
import { DiskUsagePage } from "@/features/admin/disk-usage-page";
import { ensureSuperAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/dyski")({
	beforeLoad: async () => {
		await ensureSuperAdminAccess();
	},
	component: DiskUsagePage,
});
